import styled from 'styled-components/macro'

const ResultActionIcon = styled.i`
  font-size: 14px;
  color: #eaeaee;
  margin-left: 20px;
`
export default ResultActionIcon
